import { useCountDownTimer } from "@website/ui/count-down-timer/count-down-timer.hook";
import styles from "@website/ui/count-down-timer/count-down-timer.module.scss";
import { CountDownTimerPropertiesType } from "@website/ui/count-down-timer/count-down-timer.types";
import { FC, memo } from "react";

const CountDownTimer: FC<CountDownTimerPropertiesType> = (properties) => {
  const { containerReference } = useCountDownTimer(properties);

  return <span className={styles["container"]} ref={containerReference} />;
};

const CountDownTimerMemoized = memo(CountDownTimer);
export { CountDownTimerMemoized as CountDownTimer };
